import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';
import Header from '../components/Header';
import Footer from '../components/Footer';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

export default function TauxDispo() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) navigate('/login');

    const fetchTaux = async () => {
      try {
        const res = await api.get('/taux-dispo', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(res.data);
      } catch (err) {
        console.error('Erreur récupération taux dispo:', err);
      }
    };
    fetchTaux();
  }, [navigate]);

  return (
    <>
      <Header />
      <main className="container large-container">
        <h2>Taux de disponibilité des applications (30 derniers jours)</h2>

        {data.length === 0 ? (
          <p>Aucune donnée à afficher.</p>
        ) : (
          <div style={{ width: '100%', height: 400 }}>
            <ResponsiveContainer>
              <BarChart
                data={data}
                margin={{ top: 20, right: 30, left: 0, bottom: 20 }}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis
                  dataKey="nom"
                  angle={-15}
                  textAnchor="end"
                  height={60}
                  interval={0}
                  tick={{ fontSize: 12 }}
                />
                <YAxis domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
                <Tooltip formatter={(v) => `${v}%`} />
                <Bar
                  dataKey="taux_disponibilite"
                  fill="#1976d2"
                  radius={[4, 4, 0, 0]}
                  maxBarSize={60}
                >
                  <LabelList
                    dataKey="taux_disponibilite"
                    position="top"
                    formatter={(v) => `${v}%`}
                    style={{ fill: '#333', fontSize: 12 }}
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </main>
      <Footer />
    </>
  );
}
